import React from 'react';
import { IconEyeSlash, IconDocument, IconShieldCheck } from './icons';

function LockIcon(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="5" y="11" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 11 V7.5 a4 4 0 0 1 8 0 V11" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

const ITENS = [
  { Icon: LockIcon, titulo: 'Sem login', texto: 'Acesso público e simples' },
  { Icon: IconEyeSlash, titulo: 'Sem cookies de rastreio', texto: 'Sua privacidade é respeitada' },
  { Icon: IconDocument, titulo: 'Identidade nunca registrada', texto: 'Se você optar pelo anonimato' },
  { Icon: IconShieldCheck, titulo: 'Sigilo e confidencialidade', texto: 'Tratamento seguro por nossa equipe de compliance' },
];

function TrustBar() {
  return (
    <div className="trust-bar">
      {ITENS.map(({ Icon, titulo, texto }) => (
        <div className="trust-bar__item" key={titulo}>
          <span className="trust-bar__icon"><Icon /></span>
          <span>
            <strong>{titulo}</strong>
            <small>{texto}</small>
          </span>
        </div>
      ))}
    </div>
  );
}

export default TrustBar;
